import { combineReducers } from "@reduxjs/toolkit";
import { commonReducer } from "@/redux/reducers/commonReducer";
import { testKitReducer } from "@/redux/reducers/testKitReducer";
import { usersReducer } from "@/redux/reducers/usersReducer";
import { chatReducer } from "@/redux/reducers/chatReducer";
import { homeReducer } from "@/redux/reducers/homeReducer";
import { questionnaireReducer } from "./questionnaireReducer";

const rootReducer = combineReducers({
  common: commonReducer,
  testKit: testKitReducer,
  users: usersReducer,
  chat: chatReducer,
  home: homeReducer,
  questionnaire: questionnaireReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
